/* me-header.js — drawer mobile + état sticky pour la section me-header */
(function () {
  function init() {
    var root = document.querySelector('me-header');
    if (!root) return;

    var drawer = root.querySelector('[data-me-drawer]');
    var overlay = root.querySelector('[data-me-overlay]');
    var openBtns = root.querySelectorAll('[data-me-open]');
    var closeBtns = root.querySelectorAll('[data-me-close]');

    function open() {
      if (!drawer) return;
      drawer.hidden = false; if (overlay) overlay.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); });
      document.body.classList.add('me-no-scroll');
      var f = drawer.querySelector('a,button'); if (f) f.focus();
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('me-no-scroll');
      setTimeout(function () { drawer.hidden = true; if (overlay) overlay.hidden = true; }, 320);
    }
    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    closeBtns.forEach(function (b) { b.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    // Sticky : ajoute .is-scrolled au-delà de 20px (collapse barre utilitaire)
    var onScroll = function () { root.classList.toggle('is-scrolled', window.scrollY > 20); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Masque la pastille compteur quand le panier est vide (sinon "0" reste affiché)
    var cartIcon = root.querySelector('cart-icon');
    if (cartIcon) {
      var countEl = cartIcon.querySelector('[data-ref="cart-count"]');
      if (countEl) {
        var syncEmpty = function () { cartIcon.classList.toggle('me-cart-empty', (parseInt(countEl.textContent, 10) || 0) <= 0); };
        syncEmpty();
        new MutationObserver(syncEmpty).observe(countEl, { childList: true, characterData: true, subtree: true });
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
